import React, { useState, useMemo } from 'react';

import { AxiosError } from 'axios';
import { debounce } from 'lodash';
import { useFormContext, Controller } from 'react-hook-form';
import { GroupBase, StylesConfig } from 'react-select';
import AsyncSelect from 'react-select/async';
import { SelectStyle } from 'src/accounts/utils';

import { fetchAccounts } from '../api';

type CallbackType = (accounts: AccountType[]) => void;
type AccountType = { name: string; id: string };

const AccountSearch: React.FC = () => {
  const [searchError, setSearchError] = useState('');
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fetch = (value: string, callback: CallbackType): void => {
    fetchAccounts(value, true)
      .then(({ data }) => {
        callback(data.results);
      })
      .catch((err) => {
        const error = err as AxiosError<{ detail: string }>;
        const detail = error?.response?.data?.detail;
        setSearchError(detail || 'An unknown error has occurred');
        callback([]);
      });
  };

  const debounceHandler = useMemo(() => debounce(fetch, 1000), []);

  return (
    <div className="relative mt-4">
      <label htmlFor="search-salesforce">
        <p className="input-label">Account</p>
        <Controller
          name="accountPayload"
          render={({ field }) => (
            <AsyncSelect
              styles={SelectStyle as StylesConfig<AccountType, false, GroupBase<AccountType>>}
              aria-label="Account"
              cacheOptions
              defaultOptions
              loadOptions={debounceHandler}
              getOptionLabel={(option: AccountType) => option.name}
              getOptionValue={(option: AccountType) => option.id}
              className="sm:w-1/2 w-full"
              placeholder=""
              {...field}
            />
          )}
          defaultValue={null}
          control={control}
          rules={{ required: true }}
        />
        {searchError && <p className="error-text">{searchError}</p>}
        {errors.accountPayload && (
          <p className="error-text">There was an error fetching the current account.</p>
        )}
      </label>
    </div>
  );
};

export default AccountSearch;
